export default {
  root: {
    position: "absolute",
    top: 0,
    width: "100%",
    '@media (max-width: 600px)': {
      height: 63,
      background: "white"
    }
  },
  logo: {
    position: "absolute",
    left: 27,
    top: 17,
    zIndex: 10
  },
  gloryToUkraine: {
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 10
  }
};
